import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";

type Props = {
  totalItems: number;
  itemsPerPage: number;
  currentPage: number;
  onPageChange: (page: number) => void;
};
export default function CommonPagination({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
}: Props) {
  const pageCount: number = 5;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const currentPageGroup = ~~((currentPage - 1) / pageCount);

  const handlePageClick = (page: number) => {
    onPageChange(page);
  };

  const handlePrevGroup = () => {
    const newPage = currentPage - 1;
    if (newPage > 0) {
      onPageChange(newPage);
    }
  };

  const handleNextGroup = () => {
    if ((currentPageGroup + 1) * pageCount < totalPages) {
      const newPage = currentPage + 1;
      onPageChange(newPage);
    }
  };

  const renderPageNumbers = () => {
    const startPage = currentPageGroup * pageCount + 1;
    const endPage = Math.min(startPage + 4, totalPages);

    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <PaginationItem key={i}>
          <PaginationLink
            isActive={i === currentPage}
            onClick={() => {
              handlePageClick(i);
            }}
          >
            {i}
          </PaginationLink>
        </PaginationItem>
      );
    }

    return pageNumbers;
  };

  return (
    <Pagination>
      <PaginationContent>
        <PaginationItem aria-disabled={currentPageGroup === 0}>
          <PaginationPrevious onClick={handlePrevGroup} />
        </PaginationItem>
        {renderPageNumbers()}
        <PaginationItem>
          <PaginationNext
            aria-disabled={(currentPageGroup + 1) * pageCount >= totalPages}
            onClick={handleNextGroup}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
}
